import { Link } from "react-router-dom";
import { Card } from "../components/Card";
import { Disclaimer } from "../components/Disclaimer";
import { config } from "../lib/config";
import { companyLegalNameAr, valuationUnitNameAr } from "../lib/constants";

const trustPoints = [
  {
    value: "1990",
    title: "خبرة ممتدة",
    description: "خبرة هندسية تراكمية في مشاريع التصميم والإشراف وإدارة المشاريع.",
  },
  {
    value: "محلية",
    title: "معرفة بالسوق",
    description: "فهم لطبيعة الأصول والجهات المستفيدة ومتطلبات القرار داخل المملكة.",
  },
  {
    value: "مهنية",
    title: "منهجية موثقة",
    description: "عمل مبني على الدقة، الأمانة المهنية، والخبرة الميدانية.",
  },
];

const engineeringServices = [
  "التصميم الهندسي",
  "الإشراف على التنفيذ",
  "إدارة المشاريع",
  "التقييمات الفنية الهندسية",
  "تقييم الأضرار والحالة الفنية",
  "تقدير تكلفة الإصلاح",
];

const servedSectors = [
  "الجهات البنكية والتمويلية",
  "شركات التأمين",
  "المطورون العقاريون",
  "ملاك ومديرو المحافظ العقارية",
  "الجهات المالكة للأصول",
  "فرق إدارة المشاريع والترميم",
];

export function Home() {
  return (
    <>
      <section data-qa="home-hero" className="relative isolate overflow-hidden bg-charcoal text-white">
        <img
          src="/assets/hero-engineering-assessment.png"
          alt=""
          className="absolute inset-0 -z-10 h-full w-full object-cover opacity-42"
        />
        <div className="absolute inset-0 -z-10 bg-gradient-to-l from-charcoal via-charcoal/88 to-charcoal/45" />
        <div className="container grid min-h-[560px] items-center py-14 md:min-h-[620px] md:py-20">
          <div className="max-w-3xl">
            <p className="eyebrow">خبرة هندسية منذ 1990</p>
            <h1 className="text-[2.35rem] font-bold leading-[1.3] md:text-[3.25rem] md:leading-[1.25]">
              {companyLegalNameAr}
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-9 text-white/78">
              خبرة هندسية منذ 1990 في التصميم، الإشراف، إدارة المشاريع،
              والتقييمات الفنية.
            </p>
            <p className="mt-4 max-w-3xl text-base leading-8 text-white/72">
              منذ عام 1990، تعمل شركة كيان الاستشارات الهندسية في تقديم خدمات
              هندسية متخصصة تقوم على الدقة، الأمانة المهنية، والخبرة الميدانية.
              وقد امتدت خبرة الشركة عبر قطاعات متعددة من خلال خدمات التصميم،
              الإشراف، إدارة المشاريع، والتقييمات الفنية الهندسية.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link className="btn btn-secondary" to="/valuation-unit">
                تعرف على وحدة تقييم الأصول العقارية
              </Link>
              <Link className="btn btn-gold" to="/request-evaluation">
                طلب تقييم أصول عقارية
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
          <div>
            <p className="eyebrow">عن الشركة</p>
            <h2 className="text-[2rem] font-bold leading-[1.35] text-charcoal md:text-[2.35rem] md:leading-[1.3]">
              بيت خبرة هندسي لخدمات التصميم والإشراف وإدارة المشاريع
            </h2>
          </div>
          <div className="space-y-5 text-lg leading-10 text-graphite">
            <p>
              تعمل {companyLegalNameAr} على تقديم خدمات هندسية متخصصة للجهات
              المالكة والمطورة والممولة، مع تركيز على جودة القرار الفني ووضوح
              نطاق العمل وموثوقية المخرجات.
            </p>
            <p>
              تجمع الشركة بين الخبرة الميدانية والانضباط المهني في التعامل مع
              الأصول والمشاريع، من مراحل الدراسة والتصميم إلى الإشراف والمتابعة
              والتقييمات الفنية.
            </p>
          </div>
        </div>
      </section>

      <section className="border-y border-line bg-sand py-20">
        <div className="container">
          <p className="eyebrow">الثقة والخبرة</p>
          <h2 className="max-w-3xl text-[2rem] font-bold leading-[1.35] text-charcoal md:text-[2.35rem] md:leading-[1.3]">
            خبرة هندسية تساعد الجهات على اتخاذ قرار أوضح
          </h2>
          <div className="mt-10 grid gap-4 md:grid-cols-3">
            {trustPoints.map((point) => (
              <Card key={point.title}>
                <span className="text-3xl font-bold text-gold">{point.value}</span>
                <h3 className="mt-4 text-xl font-bold text-charcoal">{point.title}</h3>
                <p className="mt-3 leading-8 text-ash">{point.description}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container grid gap-10 lg:grid-cols-[0.8fr_1.2fr]">
          <div>
            <p className="eyebrow">الخدمات الهندسية</p>
            <h2 className="text-[2rem] font-bold leading-[1.35] text-charcoal md:text-[2.35rem] md:leading-[1.3]">
              خدمات متكاملة تغطي دورة المشروع والقرار الفني
            </h2>
            <p className="mt-5 text-lg leading-9 text-ash">
              تشمل أعمال الشركة التصميم، الإشراف، إدارة المشاريع، والتقييمات
              الفنية التي تدعم قرارات الملكية والتمويل والتأمين وإدارة الأصول.
            </p>
          </div>
          <div className="grid gap-4 md:grid-cols-2">
            {engineeringServices.map((service) => (
              <Card key={service}>
                <h3 className="text-xl font-bold text-charcoal">{service}</h3>
                <p className="mt-3 leading-8 text-ash">
                  خدمة هندسية تنفذ ضمن نطاق عمل واضح ومخرجات قابلة للمراجعة من
                  الجهة المستفيدة.
                </p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="border-y border-line bg-sand py-20">
        <div className="container">
          <p className="eyebrow">القطاعات المخدومة</p>
          <h2 className="max-w-3xl text-[2rem] font-bold leading-[1.35] text-charcoal md:text-[2.35rem] md:leading-[1.3]">
            خدمات موجهة لجهات تحتاج رأيًا هندسيًا موثقًا
          </h2>
          <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {servedSectors.map((sector) => (
              <Card key={sector}>
                <h3 className="text-xl font-bold text-charcoal">{sector}</h3>
                <p className="mt-3 leading-8 text-ash">
                  دعم فني يساعد على فهم الحالة الهندسية ونطاق المخاطر وتكلفة
                  التدخل عند الحاجة.
                </p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <div>
            <p className="eyebrow">{valuationUnitNameAr}</p>
            <h2 className="text-[2rem] font-bold leading-[1.35] text-charcoal md:text-[2.35rem] md:leading-[1.3]">
              {config.combinedUnitNameAr}
            </h2>
          </div>
          <div>
            <p className="text-lg leading-10 text-graphite">
              وتأتي وحدة تقييم الأصول العقارية كإحدى الوحدات المتخصصة في شركة
              كيان الاستشارات الهندسية، لتقديم تقييم هندسي مستقل للحالة الفنية
              والأضرار وتكلفة الإصلاح، دعماً لقرارات التمويل والتأمين.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link className="btn btn-primary" to="/valuation-unit">
                تعرف على وحدة تقييم الأصول العقارية
              </Link>
              <Link className="btn btn-secondary" to="/request-evaluation">
                طلب تقييم أصول عقارية
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-sand py-10">
        <div className="container">
          <Disclaimer />
        </div>
      </section>
    </>
  );
}
